<template>
  <div
    class="rounded-extra-small flex flex-col overflow-hidden"
    :class="[expanded && 'rounded-large my-1']"
  >
    <div
      class="group bg-surface rounded-b-extra-small relative flex w-full flex-row items-center overflow-hidden px-3 py-2"
      :class="[isExpandable && 'cursor-pointer']"
      @click="toggleExpanded"
    >
      <BaseMemberAvatar :member="member" />
      <span class="text-label-large ml-2">{{ memberShortName(member) }}</span>
      <div class="ml-auto flex flex-row items-center gap-1">
        <TendencyBage v-if="tendency" :tendency="tendency" />
        <span v-if="average" class="text-title-large w-14 text-right font-bold">{{
          useDisplayPercentage(average)
        }}</span>
        <span class="text-label-medium ml-4"
          >{{ numberOfAnswers }} {{ $t('common.answer', numberOfAnswers) }}</span
        >
        <div
          v-if="numberOfTextFeedbacks > 0"
          class="bg-tertiary-container text-on-tertiary-container rounded-medium relative ml-2 flex flex-row items-center gap-1 px-1.5 py-0.5"
        >
          <BaseIcon size="16">chat_bubble</BaseIcon>
          <span class="text-label-small">{{ numberOfTextFeedbacks }}</span>
        </div>
        <BaseIcon v-if="isExpandable" size="20" class="ml-2" :class="[expanded && 'rotate-180']"
          >keyboard_arrow_down</BaseIcon
        >
        <div v-else class="w-7"></div>
      </div>
      <BaseStateLayer v-if="isExpandable" type="surface-neutral" />
    </div>
    <JournalAnalysisMemberItemBody
      v-if="expanded"
      :member="member"
      :feedbacks="
        feedbacks.map((feedback) => ({
          questionId: feedback.question.id,
          value: feedback.value,
          id: feedback.id,
          text: feedback.text,
        }))
      "
      :questions="feedbacks.map((feedback) => feedback.question)"
    />
  </div>
</template>

<script setup lang="ts">
  import { computed, ref } from 'vue'
  import type { Member } from '@/core/models/member/member'
  import BaseMemberAvatar from '../base/avatar/BaseMemberAvatar.vue'
  import TendencyBage from '../base/tendency-badge/TendencyBage.vue'
  import { useDisplayPercentage } from '@/core/composables/use-display-percentage'
  import BaseIcon from '../base/icon/BaseIcon.vue'
  import BaseStateLayer from '../base/state-layer/BaseStateLayer.vue'
  import JournalAnalysisMemberItemBody from './JournalAnalysisMemberItemBody.vue'
  import { memberShortName } from '@/core/models/member/member-name.ts'

  interface Props {
    tendency: number | null
    average: number | null
    member: Member
    feedbacks: ReadonlyArray<{
      id: string
      value: number | null
      text: JSON | null
      question: {
        id: string
        text: string
      }
    }>
  }

  const props = defineProps<Props>()

  const expanded = ref(false)

  const toggleExpanded = () => {
    if (isExpandable.value) {
      expanded.value = !expanded.value
    }
  }

  const numberOfAnswers = computed(() => {
    return props.feedbacks.length
  })

  const isExpandable = computed(() => {
    return props.feedbacks.length > 0
  })
  const numberOfTextFeedbacks = computed(() => {
    return props.feedbacks.filter((feedback) => feedback.text).length
  })
</script>
